<section class="page-title-area">
    <div class="container">
        <div class="page-title-content" *ngFor="let pageTitle of pageTitleArea">
            <h2>{{ pageTitle.title }}</h2>
            <ul>
                <li><a routerLink="/">Home</a></li>
                <li>{{ pageTitle.title }}</li>
            </ul>
        </div>
    </div>

    <div class="shape-img1">
        <img src="assets/img/shape/shape1.svg" alt="image" />
    </div>
    <div class="shape-img2">
        <img src="assets/img/shape/shape2.png" alt="image" />
    </div>
    <div class="shape-img3">
        <img src="assets/img/shape/shape3.png" alt="image" />
    </div>
</section>

<section class="courses-area pb-100 bg-fafafb">
    <div class="container">
        <div class="row">
            <div class="courses-overview" style="margin-bottom: 125px">
                <h3>Learning can happen anywhere, anytime</h3>
                <p>
                    This University is always open for learning. There are
                    several online classes and hands-on labs available to users
                    and consumers of data.
                </p>
                <p>
                    Data Producers are people that are on the front lines, that
                    enter data into the systems. The Data Producers control the
                    instruments that are used for physical data production if
                    that data is produced from within the organization or if
                    that data is produced by an outside source.
                </p>
                <p>
                    Data Consumers are the people that use data as part of their
                    job. Data Users include people that request and use data on
                    reports to make decisions. Data Users are people that
                    analyze and assess the organization’s operations based on
                    data they receive through a variety of channels. Data Users
                    are a creative lot that are always looking for better ways
                    to use the data to complete their job function.
                </p>
                <p>
                    See below for a list of courses offered for Users and
                    Consumers to begin learning.
                </p>
                <p>
                    And remember, the learning doesn’t stop here. The Community
                    of Practice is a great place to collaborate with other data
                    producers and consumers to learn and share experience.
                </p>
            </div>
        </div>
        <div _ngcontent-vfb-c71="" class="section-title">
            <h2 _ngcontent-vfb-c71="">Learning Paths</h2>
        </div>
        <div class="row">
            <div
                class="col-lg-4 col-md-6"
                *ngFor="let coursesContent of singleCoursesBox"
            >
                <div class="single-courses-box">
                    <div class="courses-image university">
                        <a
                            routerLink="/{{ coursesContent.link }}"
                            class="d-block image"
                        >
                            <img
                                [src]="coursesContent.courseImg"
                                [class]="coursesContent.courseImgClass"
                                alt="image"
                            />
                        </a>
                        <!-- <div class="price shadow {{coursesContent.coursePriceClass}}">{{coursesContent.coursePrice}}</div> -->
                    </div>

                    <div class="courses-content">
                        <!-- <div class="course-author d-flex align-items-center">
                            <img [src]="coursesContent.authorImg" class="rounded-circle" alt="image">
                            <span>{{coursesContent.authorName}}</span>
                        </div> -->

                        <h3>
                            <a routerLink="/{{ coursesContent.link }}">{{
                                coursesContent.title
                            }}</a>
                        </h3>
                        <p>{{ coursesContent.paragraphText }}</p>

                        <ul
                            class="courses-box-footer d-flex justify-content-between align-items-center"
                        >
                            <li>
                                <i class="flaticon-agendas"></i>
                                {{ coursesContent.courseDuration }}
                            </li>
                            <li>
                                <i class="flaticon-team"></i>
                                {{ coursesContent.studentApply }}
                            </li>
                        </ul>
                    </div>
                </div>
            </div>

            <!-- <div class="col-lg-12 col-md-12">
                <div class="pagination-area text-center">
                    <a routerLink="/courses" class="prev page-numbers"><i class='bx bx-chevrons-left'></i></a>
                    <span class="page-numbers current" aria-current="page">1</span>
                    <a routerLink="/courses" class="page-numbers">2</a>
                    <a routerLink="/courses" class="page-numbers">3</a>
                    <a routerLink="/courses" class="page-numbers">4</a>
                    <a routerLink="/courses" class="next page-numbers"><i class='bx bx-chevrons-right'></i></a>
                </div>
            </div> -->
        </div>
    </div>
</section>
